// extracted by mini-css-extract-plugin
module.exports = {"TransCap":"TransCap_TransCap__OW12g","TransCapUppercase":"TransCap_TransCapUppercase__gAe-N"};